import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { featuredComics } from '@/mocks/zh/comics';

export default function FeaturedSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-label text-primary-500 uppercase tracking-wider">本周精选</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
              热门<strong className="text-primary-500">推荐</strong>
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md">
              精选全网最受欢迎的韩国漫画，每一部都值得细细品读
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-label whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scroll-smooth">
          {featuredComics.slice(0, 6).map((comic) => (
            <div key={comic.id} className="w-[200px] md:w-[220px] flex-shrink-0">
              <ComicCard
                id={comic.id}
                title={comic.title}
                author={comic.author}
                category={comic.category}
                cover={comic.cover}
                rating={comic.rating}
                status={comic.status}
                latestChapter={comic.latestChapter}
                views={comic.views}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}